export const THEME_STORAGE_KEY = "ishvaram-theme";
export const THEME_CHANGE_EVENT = "ishvaram-theme-change";

export type Theme = "light" | "dark";

/**
 * Runs in <head> before the page paints so a saved dark preference never
 * flashes the light palette first. Light remains the default when the value is
 * missing, invalid, or browser storage is unavailable.
 */
export const THEME_BOOTSTRAP_SCRIPT = `(()=>{const root=document.documentElement;try{if(localStorage.getItem("${THEME_STORAGE_KEY}")==="dark"){root.setAttribute("data-theme","dark");return}}catch{}root.removeAttribute("data-theme")})()`;
